// @flow
import * as React from 'react';
import SailChartIcon from 'sail/ChartIcon';
import type {IconColor, IconSize} from 'sail/Icon/types';
import type {ChartIconType, ChartIconStyle} from 'sail/ChartIcon/types';

type ChartIconProps = {|
  icon: ChartIconType,
  iconStyle?: ChartIconStyle,
  color?: IconColor,
  size?: IconSize,
|};

export const ChartIcon = ({icon, iconStyle, color, size}: ChartIconProps) => {
  return (
    <SailChartIcon
      icon={icon}
      iconStyle={iconStyle || 'solid'}
      color={color || 'gray'}
      size={size || 16}
    />
  );
};
